import React from "react";
import { useNavigate } from "react-router-dom";
import { HiLocationMarker } from "react-icons/hi";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import vr1 from "../assets/images/c1.jpg";
import vr2 from "../assets/images/c2.jpg";
import vr3 from "../assets/images/c3.jpg";
import vr4 from "../assets/images/c4.jpg";

function LocationsSection() {
  const navigate = useNavigate();
  return (
    <div className="bg-[#fdf4e4] py-1 px-6 md:px-24 text-[#3f3a32] loc-container">
      <div className="flex flex-col md:flex-row items-start justify-between gap-10 md:gap-16">
        {/* Text - always on left in desktop, on top in mobile */}
        <div className="w-full md:w-2/5 order-1 space-y-8">
          <h2 className="text-2xl md:text-3xl font-bold text-[#3f3a32] font-mortend headings">
            WHERE TO EXPERIENCE SIGIRIYA VR?
          </h2>

          {/* Hotel 1 */}
          <div>
            <div className="flex items-center gap-2 mb-2 text-[#3f3a32] text-xl font-semibold pb-2">
              <HiLocationMarker className="text-[#7c623f]" />
              <span>Cinnamon Lodge Habarana</span>
            </div>
            <div className="flex gap-4 hotel-btn-grp">
              <button
                onClick={() => navigate('/bookings/cinnamon-lodge')}
                className="bg-[#7c623f] text-white font-semibold py-1.5 px-4 rounded-full text-sm"
              >
                Book Now
              </button>
              <a
                target="_blank"
                href="https://maps.app.goo.gl/fRNLstzeXAVJY3Ex8"
                rel="noreferrer"
              >
                <button className="bg-[#3f3a32] text-white font-semibold py-1.5 px-4 rounded-full text-sm">
                  Location
                </button>
              </a>
            </div>
          </div>

          {/* Hotel 2 */}
           <div>
             <div className="flex items-center gap-2 mb-2 text-[#3f3a32] text-xl font-semibold">
              <HiLocationMarker className="text-[#7c623f]" />
               <span>EKHO Sigiriya
</span>
             </div>
             <div className="flex gap-4 hotel-btn-grp">
               <button
                onClick={() => navigate('/bookings/ekho')}
                className="bg-[#7c623f] text-white font-semibold py-1.5 px-4 rounded-full text-sm"
              >
                Book Now
              </button>
              <a
                target="_blank"
                href="https://maps.app.goo.gl/ppsMb2wfUx8aQo4v5"
                rel="noreferrer"
              >
                <button className="bg-[#3f3a32] text-white font-semibold py-1.5 px-4 rounded-full text-sm">
                  Location
                </button>
              </a>
            </div>
          </div>

          <p className="text-[#3f3a32] font-bold mt-4 ml-2">
            Ticket Price LKR 5,000
          </p>
        </div>

        {/* Carousel - right in desktop, bottom in mobile */}
        <div className="w-full md:w-1/2  order-2">
          <Carousel
            showThumbs={false}
            showStatus={false}
            infiniteLoop={true}
            autoPlay={true}
            interval={4000}
            swipeable={true}
            emulateTouch={true}
          >
            {[vr1, vr2, vr3, vr4].map((img, index) => (
              <div key={index}>
                <img
                  src={img}
                  alt={`VR Slide ${index + 1}`}
                  className="w-full h-64 md:h-80 object-cover rounded-xl"
                />
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
}

export default LocationsSection;
